import React, { Children, cloneElement, isValidElement, PureComponent } from 'react';
import Animate from '../animate';
import createChains from '../_util/createChains';
import MouseDown from './MouseDown';
export default class RippleChild extends PureComponent {
    constructor() {
        super(...arguments);
        this.handleMouseDown = (child, size) => {
            const { prefixCls, ...rest } = this.props;
            const { children, style } = child.props;
            if (size) {
                const { x, y, width, height } = size;
                const maxWidth = Math.max(width - x, x);
                const maxHeight = Math.max(height - y, y);
                const max = Math.sqrt(maxWidth * maxWidth + maxHeight * maxHeight);
                this.currentCircleStyle = {
                    width: max + max,
                    height: max + max,
                    left: x - max,
                    top: y - max,
                };
            }
            const newProps = {
                ...createChains(rest, child.props),
                children: [
                    children,
                    React.createElement(Animate, { key: "ripple", component: "div", componentProps: this.getComponentProps(prefixCls), transitionName: size ? 'zoom-small-slow' : 'fade', hiddenProp: "hidden" }, this.currentCircleStyle && (React.createElement("div", { hidden: !size, className: prefixCls, key: "circle", style: this.currentCircleStyle }))),
                ],
                style: this.currentStyle || style,
            };
            if (size && size.position === 'static') {
                newProps.style = { ...style, position: 'relative' };
                this.currentStyle = newProps.style;
            }
            return cloneElement(child, newProps);
        };
        this.ripple = (child) => {
            if (isValidElement(child)) {
                return React.createElement(MouseDown, { rippleChild: child }, this.handleMouseDown);
            }
            return child;
        };
    }
    render() {
        const { children } = this.props;
        return this.ripple(Children.only(children));
    }
    getComponentProps(prefixCls) {
        const className = `${prefixCls}-wrapper`;
        const { componentProps } = this;
        if (!componentProps || className !== componentProps.className) {
            this.componentProps = {
                className,
            };
        }
        return this.componentProps;
    }
}
RippleChild.displayName = 'RippleChild';
